import React from "react";
import { Link } from "react-router-dom";

const ArupadaiVeeduCTA = () => {
    return (
        <section className="bg-gray-50 pt-0 pb-16 px-8 relative overflow-hidden select-none">
            {/* Background horizontal divider */}
            <div className="max-w-[1440px] mx-auto px-6 mb-12">
                <hr className="border-slate-100" />
            </div>

            {/* Background watermark text */}
            <div
                className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
                style={{ zIndex: 0 }}
            >
                <span
                    className="text-[10vw] font-black uppercase text-slate-200/40 whitespace-nowrap tracking-widest"
                    style={{ letterSpacing: "0.15em" }}
                >
                    ARUPADAI VEEDU
                </span>
            </div>

            <div className="max-w-7xl mx-auto relative z-10">
                <div className="relative overflow-hidden rounded-[3.5rem] bg-gradient-to-br from-amber-50 via-slate-50 to-orange-50/50 border border-amber-100/60 shadow-[0_20px_50px_rgba(245,158,11,0.08)] min-h-[420px] flex items-center justify-center p-8 md:p-16 lg:p-20 group">
                    
                    {/* Background Decorative Element Glows */}
                    <div className="absolute top-0 right-1/4 w-96 h-96 bg-amber-200/30 rounded-full -translate-y-1/2 blur-[100px] group-hover:scale-110 transition-transform duration-1000"></div>
                    <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-orange-200/30 rounded-full translate-y-1/2 blur-[100px] group-hover:scale-110 transition-transform duration-1000"></div>

                    {/* Content Section - Alternating Split Layout (Card Left, Text Right) */}
                    <div className="relative z-10 w-full flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-16">
                        
                        {/* Left Column: Glassmorphic Card (Title & Button) */}
                        <div className="w-full lg:w-[45%] flex flex-col items-center justify-center p-8 md:p-12 bg-gradient-to-br from-white/90 via-sky-50/30 to-purple-50/40 backdrop-blur-xl rounded-[2.5rem] border border-white/60 shadow-[0_20px_40px_rgba(0,0,0,0.03)] min-h-[280px] group-hover:scale-[1.01] transition-transform duration-500">
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight leading-[1.2] mb-8 text-center">
                                Arupadai Veedu
                            </h2>
                            <div className="w-full flex justify-center">
                                <Link
                                    to="/arupadai-veedu"
                                    className="flex justify-center gap-2 items-center mx-auto shadow-xl text-lg bg-white backdrop-blur-md font-bold isolation-auto border-gray-50 before:absolute before:inset-y-0 before:my-auto before:-left-full before:w-full before:aspect-square before:rounded-full before:bg-amber-500 hover:text-white before:-z-10 before:transition-all before:duration-700 hover:before:left-0 hover:before:scale-150 relative z-10 px-8 py-3 overflow-hidden border-2 rounded-full group transition-transform active:scale-95"
                                >
                                    Discover the Sacred Abodes
                                    <svg
                                        className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-white text-gray-50 ease-linear duration-300 rounded-full border border-gray-700 group-hover:border-none p-2 rotate-45 transition-all"
                                        viewBox="0 0 16 19"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                            className="fill-gray-800"
                                        ></path>
                                    </svg>
                                </Link>
                            </div>
                        </div>

                        {/* Right Column: Subtitle & Description */}
                        <div className="w-full lg:w-[50%] space-y-6 text-center lg:text-left">
                            <div className="flex items-center justify-center lg:justify-start gap-3 mb-2">
                                <div className="h-px w-8 bg-amber-400" />
                                <span className="text-amber-600 text-xs md:text-sm font-black tracking-[0.3em] uppercase">
                                    The Six Sacred Abodes of Murugan
                                </span>
                                <div className="h-px w-8 bg-amber-400" />
                            </div>

                            <p className="text-slate-600 text-base md:text-xl font-medium max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                                Embark on a sacred journey to the six holy hill and seashore temples of <span className="text-amber-600 font-bold">Lord Murugan</span> in Tamil Nadu. Explore the grounds of divine battles, weddings, and ultimate quietude.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default ArupadaiVeeduCTA;
